<template>
  <a-layout class="term">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="term-content">
        <!--  banner    -->
        <div class="banner">
          <div class="banner-content">
            <div class="_left">
              <h1>{{ $t('investment.term_finance') }}</h1>
              <p>{{ $t('investment.term_finance_desc') }}</p>
            </div>
            <div class="_right">
              <div v-if="isLogin" class="account">
                <div class="head">
                  <div class="row">
                    <span class="font-12 cursor">{{ $t('investment.term_position_valuation') }} <icon-caret-down class="cursor"/></span>
                    <icon-eye v-if="!hideBalance" @click="toggleBalance" class="cursor"/>
                    <icon-eye-invisible v-else @click="toggleBalance" class="cursor"/>
                  </div>
                  <div class="row">
                    <span class="font-18 font-bold">{{ hideBalance ? '******' : userData.totalValue }}</span>
                  </div>
                  <div class="row">
                    <span class="font-12">{{ $t('investment.cumulative_earnings') }}</span>
                  </div>
                  <div class="row">
                    <span class="font-14">{{ hideBalance ? '******' : userData.totalIncome }}</span>
                  </div>
                </div>
                <div class="bottom">
                  <a-button class="button" @click="goToAccount">{{ $t('investment.go_to_account') }}</a-button>
                </div>
              </div>
              <div v-else class="not-log">
                <svg width="50" height="50" viewBox="0 0 66 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M52.962 3.83c3.23 4.245 2.435 10.285-1.776 13.49-4.212 3.204-10.245 2.36-13.475-1.886-3.23-4.245-2.435-10.285 1.776-13.49C43.7-1.26 49.732-.415 52.962 3.83Z"
                      fill="#9C69FF"></path>
                  <path
                      d="M23.228 29.47c-4.163-5.471-3.138-13.254 2.29-17.383 5.426-4.13 13.2-3.042 17.363 2.429 4.163 5.47 3.138 13.253-2.29 17.382-5.426 4.13-13.2 3.042-17.363-2.428Z"
                      fill="#05C3DD"></path>
                  <g filter="url(#assetLogin_svg__a)">
                    <rect x="9" y="22" width="47" height="33" rx="1.82" fill="url(#assetLogin_svg__b)"
                          fill-opacity="0.5"></rect>
                    <rect x="8.75" y="21.75" width="47.5" height="33.5" rx="2.07" stroke="#393939"
                          stroke-width="0.5"></rect>
                  </g>
                  <path fill="#05C3DD" d="M47.233 35.597H58v6.63H47.233z"></path>
                  <defs>
                    <linearGradient id="assetLogin_svg__b" x1="10.152" y1="32.033" x2="15.541" y2="7.514"
                                    gradientUnits="userSpaceOnUse">
                      <stop stop-color="#B8B8B8"></stop>
                      <stop offset="1" stop-color="#393939" stop-opacity="0"></stop>
                    </linearGradient>
                    <filter id="assetLogin_svg__a" x="0.191" y="13.191" width="64.618" height="50.618"
                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                      <feGaussianBlur in="BackgroundImageFix" stdDeviation="4.154"></feGaussianBlur>
                      <feComposite in2="SourceAlpha" operator="in"
                                   result="effect1_backgroundBlur_2497_16220"></feComposite>
                      <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_2497_16220" result="shape"></feBlend>
                    </filter>
                  </defs>
                </svg>
                <p>{{ $t('investment.login_to_view_earnings') }}</p>
                <a-button class="button" @click="goToLogin">{{ $t('investment.login') }}</a-button>
              </div>
            </div>
          </div>
        </div>
        <!--    main  -->
        <div class="f-main-wrap flex flex-column align-center jus-center">
          <div class="f-main-con">
            <!--            -->
            <div class="_top flex align-center jus-bet">
              <div class="_top-left flex align-center">
                <span class="_title">{{ $t('investment.capital_guaranteed_products') }}</span>
<!--                <img @click="toEary" src="@/assets/images/term/termAd-cn.png">-->
              </div>
              <div class="_top-right flex align-center pointer">
                <a-input class="search" :placeholder="$t('investment.search_currency')">
                  <template #prefix>
                    <icon-search />
                  </template>
                </a-input>
              </div>
            </div>
            <!--              -->
            <div class="_list">
              <div class="list-tab">
                <span>{{ $t('investment.currency') }}</span>
                <span>{{ $t('investment.product_name') }}</span>
                <span>{{ $t('investment.expected_annual_return') }}</span>
                <span>{{ $t('investment.term') }}</span>
                <span>{{ $t('investment.operation') }}</span>
              </div>
              <div v-if="loading" class="loading-container">
                <a-spin size="large" />
                                  <p>{{ $t('investment.loading') }}</p>
              </div>
              <div v-else-if="coinList.length === 0" class="empty-container">
                                  <a-empty :description="$t('investment.no_products')" />
              </div>
              <div v-else class="list-con">
                <div class="cell-box pointer" v-for="(item,index) in coinList" :key="index" @click="toDetail(index)">
                  <div class="box-con flex align-center jus-bet">
                    <div class="c-item flex align-center">
                      <img :src="require('@/assets/images/coin/' + item.type + '.png')" 
                           @error="handleImageError"
                           :alt="item.type"/>
                      <span class="uppercase"> {{ item.type }}</span>
                    </div>
                    <div class="c-item flex align-center">
                      <span>{{ item.name }}</span>
                    </div>
                    <div class="c-item flex align-center">
                      <span class="color-green">{{ item.rate }}</span>
                    </div>
                    <div class="c-item flex align-center">
                      <span>{{ item.day }}</span>
                    </div>
                    <div class="c-item flex align-center">
                                                <a-button class="button" @click.stop="goToSubscribe(index)">{{ $t('investment.subscribe') }}</a-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          -->
          <div class="f-main-bottom flex flex-column align-start">
            <p class="_title">DBG {{ $t('investment.term_finance') }} Q&A</p>
            <div class="collapse-box">
              <a-collapse expand-icon-position="right" :default-active-key="['1']">
                <a-collapse-item :header="$t('investment.faq_what_is_term_finance')" key="1">
                  <p>{{ $t('investment.faq_what_is_term_finance_desc') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.faq_how_to_subscribe')" key="2">
                  <p>{{ $t('investment.product_description') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.faq_how_to_calculate_earnings')" key="3">
                  <p>{{ $t('investment.faq_earnings_calculation_desc') }}</p>
                  <p>{{ $t('investment.faq_earnings_rule_first') }}</p>
                  <p>{{ $t('investment.faq_earnings_rule_second') }}</p>
                  <p>{{ $t('investment.faq_earnings_rule_third') }}</p>
                  <p>{{ $t('investment.faq_example_user_a') }}</p>
                  <p>{{ $t('investment.faq_example_confirm') }}</p>
                  <p>{{ $t('investment.faq_example_first_interest') }}</p>
                  <p>{{ $t('investment.faq_example_second_interest') }}</p>
                  <p>{{ $t('investment.faq_example_daily_interest') }}</p>
                  <p>{{ $t('investment.faq_example_redemption') }}</p>
                  <p>{{ $t('investment.faq_example_total') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.faq_supported_currencies')" key="4">
                  <p>{{ $t('investment.faq_supported_currencies_content') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.faq_how_to_redeem')" key="5">
                  <p>{{ $t('investment.faq_how_to_redeem_desc') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.faq_why_earnings_fluctuate')" key="6">
                  <p>{{ $t('investment.faq_why_earnings_fluctuate_desc') }}</p>
                </a-collapse-item>
              </a-collapse>
            </div>
          </div>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import Footer from "@/components/Footer/footer.vue";
import PageNav from "@/components/PageNav/PageNav.vue";
import notlog from "@/components/notlog/notlog.vue";
import { mapGetters } from 'vuex';
import financingApi from '@/common/api/financing.js';

export default {
  components: {notlog, PageNav, Footer},
  computed: {
    ...mapGetters(['isLogin', 'accounts', 'userTheme'])
  },
  data() {
    return {
      coinList: [],
      loading: false,
      hideBalance: false,
      userData: {
        totalValue: '-- USDT',
        totalIncome: '0.00'
      }
    }
  },
  mounted() {
    console.log('Term页面加载，当前登录状态:', this.isLogin);
    this.fetchFinancingProducts();
    if (this.isLogin) {
      this.loadUserData();
    }
  },
  watch: {
    isLogin: {
      handler(newVal) {
        console.log('Term页面登录状态变化:', newVal);
        if (newVal) {
          // 用户已登录，可以加载用户相关数据
          this.loadUserData();
        }
      },
      immediate: true
    },
    // 监听主题变化，强制更新样式
    userTheme: {
      handler(newTheme, oldTheme) {
        if (newTheme !== oldTheme) {
          // 主题切换时，强制触发样式更新
          this.$nextTick(() => {
            // 强制重新渲染，确保CSS变量正确应用
            this.$forceUpdate();
          });
        }
      },
      immediate: false
    }
  },
  methods: {
    toEary() {
      this.$router.push("/HomeView/investment/easyEarn")
    },
    toDetail(index) {
      console.log('跳转到产品详情，索引:', index, '产品:', this.coinList[index]);
      const product = this.coinList[index];
      if (!product) {
        return;
      }
      
      // 检查是否是质押产品（基于产品名称或ID判断）
      const isPledgeProduct = this.isPledgeProduct(product);
      if (isPledgeProduct) {
        this.$router.push("/HomeView/investment/pledge");
        return;
      }
      
      // 跳转到产品详情页
      if (product.id) {
        this.$router.push(`/HomeView/investment/Term/detail?id=${product.id}`)
      } else {
        this.$router.push("/HomeView/investment/Term/detail")
      }
    },
    goToLogin() {
      this.$router.push("/Login");
    },
    goToAccount() {
      this.$router.push("/HomeView/assets");
    },
    toggleBalance() {
      this.hideBalance = !this.hideBalance;
    },
    goToSubscribe(index) {
      console.log('跳转到申购页面，索引:', index, '产品:', this.coinList[index]);
      const product = this.coinList[index];
      if (!product) {
        return;
      }
      
      // 检查是否是质押产品（基于产品名称或ID判断）
      const isPledgeProduct = this.isPledgeProduct(product);
      if (isPledgeProduct) {
        this.$router.push("/HomeView/investment/pledge");
        return;
      }
      
      // 跳转到产品详情页
      if (product.id) {
        this.$router.push(`/HomeView/investment/Term/detail?id=${product.id}`)
      } else {
        this.$router.push("/HomeView/investment/Term/detail")
      }
    },
    // 判断是否是质押产品
    isPledgeProduct(product) {
      if (!product) {
        return false;
      }
      
      // 方法1: 检查产品名称是否包含质押相关的关键词
      const pledgeKeywords = [
        'platform_token_staking',  // 多语言键名
        '质押',                    // 中文
        '質押',                    // 繁体中文
        'staking',                 // 英文
        'pledge',                  // 英文
        'ステーキング',            // 日文
        '스테이킹',                // 韩文
        'cryzentra平台',          // 后端历史产品名称，用于兼容识别
        'platform token'          // 平台代币
      ];
      
      const productName = (product.name || '').toLowerCase();
      const productContent = (product.content || '').toLowerCase();
      
      // 检查产品名称或内容中是否包含质押关键词
      for (const keyword of pledgeKeywords) {
        const lowerKeyword = keyword.toLowerCase();
        if (productName.includes(lowerKeyword) || 
            productContent.includes(lowerKeyword)) {
          return true;
        }
      }
      
      // 方法2: 检查产品ID（如果质押产品有固定的ID范围）
      // 这里可以根据实际情况调整ID范围
      // if (product.id && product.id >= 1000) {
      //   return true;
      // }
      
      // 方法3: 检查产品类型或其他标识字段
      // if (product.type === 'pledge' || product.category === 'staking') {
      //   return true;
      // }
      
      return false;
    },
    async fetchFinancingProducts() {
      try {
        this.loading = true;
        console.log('开始获取理财产品列表...');
        const response = await financingApi.list();
        console.log('理财产品列表响应:', response);
        
        if (response && response.data && response.data.list) {
          this.coinList = response.data.list.map(item => ({
            id: item.id,
            type: (item.buy_currency || 'USDT').toLowerCase(),
                          name: item.name || this.$t('investment.term_finance'),
            rate: (item.eay || 0) + '%',
                            day: (item.time_limit || 0) + ' ' + this.$t('investment.days'),
            eay: item.eay || 0,
            time_limit: item.time_limit || 0,
            content: item.content || ''
          }));
          console.log('处理后的产品列表:', this.coinList);
        } else {
          console.warn('理财产品列表数据格式异常:', response);
          // 如果API失败，使用默认数据
          this.coinList = [{
            id: 1,
            type: "usdt",
            name: this.$t('investment.one_hundred_eighty_day_premium'),
            rate: "7%",
            day: "180 " + this.$t('investment.days'),
            eay: 7,
            time_limit: 180,
            content: this.$t('investment.one_hundred_eighty_day_premium')
          }, {
            id: 2,
            type: "usdt",
            name: this.$t('investment.ninety_day_premium'),
            rate: "5%",
            day: "90 " + this.$t('investment.days'),
            eay: 5,
            time_limit: 90,
            content: this.$t('investment.ninety_day_premium')
          }, {
            id: 3,
            type: "usdt",
            name: this.$t('investment.fourteen_day_premium'),
            rate: "2.5%",
            day: "14 " + this.$t('investment.days'),
            eay: 2.5,
            time_limit: 14,
            content: this.$t('investment.fourteen_day_premium')
          }, {
            id: 4,
            type: "usdt",
            name: this.$t('investment.platform_token_staking'),
            rate: "1.5% ~ 2.6%",
            day: "180 " + this.$t('investment.days'),
            eay: 2.05,
            time_limit: 180,
            content: this.$t('investment.platform_token_staking')
          }];
        }
      } catch (error) {
        console.error('获取理财产品列表失败:', error);
        // 使用默认数据作为备用
        this.coinList = [{
          id: 1,
          type: "usdt",
          name: this.$t('investment.one_hundred_eighty_day_premium'),
          rate: "7%",
          day: "180 " + this.$t('investment.days'),
          eay: 7,
          time_limit: 180,
          content: this.$t('investment.one_hundred_eighty_day_premium')
        }, {
          id: 2,
          type: "usdt",
          name: this.$t('investment.ninety_day_premium'),
          rate: "5%",
          day: "90 " + this.$t('investment.days'),
          eay: 5,
          time_limit: 90,
          content: this.$t('investment.ninety_day_premium')
        }, {
          id: 3,
          type: "usdt",
          name: this.$t('investment.fourteen_day_premium'),
          rate: "2.5%",
          day: "14 " + this.$t('investment.days'),
          eay: 2.5,
          time_limit: 14,
          content: this.$t('investment.fourteen_day_premium')
        }, {
          id: 4,
          type: "usdt",
          name: this.$t('investment.platform_token_staking'),
          rate: "1.5% ~ 2.6%",
          day: "180 " + this.$t('investment.days'),
          eay: 2.05,
          time_limit: 180,
          content: this.$t('investment.platform_token_staking')
        }];
      } finally {
        this.loading = false;
      }
    },
    async loadUserData() {
      try {
        console.log('开始加载用户理财数据...');
        
        // 并行请求两个接口
        const [currentHoldingsResponse, totalIncomeResponse] = await Promise.all([
          financingApi.currentHoldings(),
          financingApi.totalIncome()
        ]);
        
        console.log('当前持仓接口响应:', currentHoldingsResponse);
        console.log('累计收益接口响应:', totalIncomeResponse);
        
        // 处理当前持仓数据
        // 返回格式: { success: true, data: { total_amount: "10000.00", count: 2, holdings: [...] } }
        let totalValue = 0;
        if (currentHoldingsResponse && 
            currentHoldingsResponse.success && 
            currentHoldingsResponse.data && 
            currentHoldingsResponse.data.total_amount) {
          totalValue = parseFloat(currentHoldingsResponse.data.total_amount) || 0;
        }
        
        // 处理累计收益数据
        // 返回格式: { success: true, data: { total_income: "500.00", count: 1, income_by_currency: [...] } }
        let totalIncome = 0;
        if (totalIncomeResponse && 
            totalIncomeResponse.success && 
            totalIncomeResponse.data && 
            totalIncomeResponse.data.total_income) {
          totalIncome = parseFloat(totalIncomeResponse.data.total_income) || 0;
        }
        
        // 更新用户数据
        this.userData = {
          totalValue: totalValue > 0 ? totalValue.toFixed(2) + ' USDT' : '-- USDT',
          totalIncome: totalIncome.toFixed(2)
        };
        
        console.log('用户数据更新:', this.userData);
      } catch (error) {
        console.error('加载用户理财数据失败:', error);
        // 保持默认值
        this.userData = {
          totalValue: '-- USDT',
          totalIncome: '0.00'
        };
      }
    },
    handleImageError(event) {
      console.warn('图片加载失败:', event.target.src);
      // 设置默认图片
      event.target.src = require('@/assets/images/coin/usdt.png');
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./term.scss";
</style>
